import React, { Fragment } from 'react'
import classNames from 'classnames'
import { Heading, Paragraph } from '@scentregroup/ui'
import { WhatsOnRange } from '@scentregroup/shared/types/whats-on'
import { getTimeRangeSlug } from '../../helpers/time-ranges'
import { PromotionPositionContext } from '../../context'
import WhatsOnListItem from './whats-on-list-item'
import styles from './index.module.scss'

export interface WhatsOnListProps {
  ranges: WhatsOnRange[]
  id?: string
  analyticsDisplayId?: string
}

const WhatsOnList = ({
  ranges,
  id,
  analyticsDisplayId,
}: WhatsOnListProps): React.ReactElement => {
  return (
    <div
      className={classNames(styles.whatsOnListContainer, styles.evolved)}
      id={id}
      aria-live="polite"
    >
      {ranges.map(range => {
        const slug = getTimeRangeSlug(range.name)
        const items = range.items
        return (
          <Fragment key={range.name}>
            <div className={styles.dividerContainer}>
              <Heading
                type="megasmalldivider"
                className={styles.divider}
                id={`${slug}-heading`}
              >
                {range.name}
              </Heading>
              {items.length !== 0 && (
                <div className={styles.countPill}>
                  {`${items.length} item${items.length === 1 ? '' : 's'}`}
                </div>
              )}
            </div>
            {items.length === 0 ? (
              <div className={styles.emptyGroup}>
                <Paragraph>
                  No content on {range.name.toLowerCase()} please change your
                  search criteria
                </Paragraph>
              </div>
            ) : (
              <ul id={`${slug}-list`} className={styles.list}>
                <PromotionPositionContext.Provider
                  value={`${analyticsDisplayId}/${slug}`}
                >
                  {items.map((item, i) => (
                    <WhatsOnListItem key={i} item={item} />
                  ))}
                </PromotionPositionContext.Provider>
              </ul>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}
export default WhatsOnList
